/* eslint-disable import/prefer-default-export */
/* eslint-disable object-curly-newline */
import {
  productListInterface,
  productsPayload,
  productGroupingList,
  modelRelacaoProdutoBeneficio,
  responsePaymentByProduct,
} from 'interfaces/Product';
import { paramsQueryString, convertQueryParamsConditionsAndFilterValues } from 'utils/objects';
import {
  createRelationshipProductBenefitPayload,
  responseRelationshipProductBenefit,
  updateRelationshipProductBenefitPayload,
} from 'interfaces/RelationshipProductBenefit';
import api from 'services';

const path = '/product';
const relationshipPath = '/relationshipProductBenefit';

// Listar produtos com filtros
export const getProductList = async (params: paramsQueryString): Promise<productListInterface> => {
  const response = await api.get<productListInterface>(`${path}/list`, {
    params: convertQueryParamsConditionsAndFilterValues(params),
  });
  return response.data;
};

// Buscar produto por ID
export const getDescriptionProduct = async (payload: productsPayload): Promise<productListInterface> => {
  const response = await api.get<productListInterface>(`${path}/${payload.productsId}`);
  return response.data;
};

// Criar produto
export const createProduct = async (payload: any): Promise<productListInterface> => {
  const response = await api.post<productListInterface>(`${path}/`, payload);
  return response.data;
};

// Atualizar produto
export const updateProduct = async (payload: { id: number; data: any }): Promise<productListInterface> => {
  const { id, data } = payload;
  const response = await api.put<productListInterface>(`${path}/${id}`, data);
  return response.data;
};

// Buscar produtos para cliente específico
export const getProductsForCustomer = async (data: { customer: string }): Promise<productListInterface> => {
  const { customer } = data;
  const response = await api.get<productListInterface>(`${path}/forCustomer/${customer}`);
  return response.data;
};

// Buscar agrupamentos de produtos
export const getProductGroupList = async (): Promise<productGroupingList> => {
  const response = await api.get<productGroupingList>(`${path}/grouping/list`);
  return response.data;
};

// Buscar benefícios por produto
export const getProductByBenefitsList = async (
  productId?: number,
): Promise<modelRelacaoProdutoBeneficio> => {
  const response = await api.get<modelRelacaoProdutoBeneficio>(`${path}/productByBenefitsList`, {
    params: { productId },
  });
  return response.data;
};

// Buscar formas de pagamento por produto
export const getPaymentByProduct = async (payload: productsPayload): Promise<responsePaymentByProduct> => {
  const response = await api.get<responsePaymentByProduct>(`${path}/payment/${payload.productsId}`);
  return response.data;
};

// Criar relacionamento produto-benefício
export const createRelationshipProductBenefit = async (
  payload: createRelationshipProductBenefitPayload,
): Promise<responseRelationshipProductBenefit> => {
  const response = await api.post<responseRelationshipProductBenefit>(`${relationshipPath}/`, payload);
  return response.data;
};

// Atualizar relacionamento produto-benefício
export const updateRelationshipProductBenefit = async (
  payload: updateRelationshipProductBenefitPayload,
): Promise<responseRelationshipProductBenefit> => {
  const { id, ...data } = payload;
  const response = await api.put<responseRelationshipProductBenefit>(`${relationshipPath}/${id}`, data);
  return response.data;
};

// Remover relacionamento produto-benefício
export const deleteRelationshipProductBenefit = async (id: number): Promise<void> => {
  await api.delete(`${relationshipPath}/${id}`);
};

// Deletar produto
export const deleteProduct = async (id: number): Promise<void> => {
  await api.delete(`${path}/${id}`);
};
